import { createService } from '@betty/toolkit/api';
import { MilestoneWinnersSchema } from './CommunityEventService.schemas';

export default createService(
  {
    getMilestoneWinners: {
      method: 'GET',
      url: ({ milestoneId }: { milestoneId: number }) =>
        `/${milestoneId}/winners`,
      responseSchema: MilestoneWinnersSchema,
    },
  },
  () => '/communityEvents',
);
